import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TimeFormat from './TimeFormat';
import { Button } from 'semantic-ui-react';
import {colors} from './../../assets/theme';
class VolunteerTimeSlot extends React.Component {

    constructor(props){
        super(props);

    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="VolunteerTimeSlot" key={this.props.key}>

                <div className="timeWrap">
                    <p className="day"><TimeFormat stamp={this.props.slot.start} type="day" /></p>
                    <p className="time">
                        <TimeFormat stamp={this.props.slot.start} type="time" />
                        {(this.props.slot && this.props.slot.start && this.props.slot.end)? '-': ''}
                        <TimeFormat stamp={this.props.slot.end} type="time" />
                    </p>
                </div>

                <div>
                    <Button size="tiny" primary onClick={this.props.onClick}>Offer Help</Button>
                </div>

                <style jsx>{`
                    .VolunteerTimeSlot {
                        
                        display: flex;
                        align-items: center;
                        padding:5px 0px;
                        border-bottom:1px solid ${colors.hiGrey};

                    }
                    .timeWrap {
                        flex:1;
                    }
                    .day {
                        font-weight:700;
                        margin:0;
                        color: ${colors.primary}
                        font-size: 13px;
                        font-weight: 700;
                        margin: 0;
                        text-transform: uppercase;
                    }
                    .time {
                        font-size:20px;
                        font-weight:300;
                        margin:0;
                        color: ${colors.primary}
                    }
                `}</style>
            </div>
        )
    }
}

VolunteerTimeSlot.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
    
    };
}

export default  connect(mapStateProps, {  })(VolunteerTimeSlot);



// WEBPACK FOOTER //
// ./src/components/common/VolunteerTimeSlot.js